package shared.utils

object ValidationUtils {
    fun isValidEmail(email: String): Boolean {
        val emailRegex = "^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$".toRegex()
        return emailRegex.matches(email)
    }
    
    fun isValidTimeRange(start: String, end: String): Boolean {
        return start != end && start.isNotBlank() && end.isNotBlank()
    }
    
    fun isNotBlank(value: String): Boolean {
        return value.trim().isNotEmpty()
    }
}

object DateUtils {
    fun getCurrentDate(): String {
        return js("new Date().toISOString().split('T')[0]") as String
    }
    
    fun getCurrentDateTime(): String {
        return js("new Date().toISOString()") as String
    }
    
    fun formatDate(isoString: String): String {
        return js("new Date(isoString).toLocaleDateString()") as String
    }
}

fun generateId(): String {
    return js("Date.now().toString() + Math.random().toString(36).substr(2, 9)") as String
}
